import type { Ref } from 'vue';
import type { PageContent } from '~/app/features/cms/types/PageContent';

const layoutHideHeaderKey = Symbol('layout-hide-header');

type PageQueryData = { page?: PageContent | null } | null | undefined;

/** Layout: own the shared hideHeader ref (default false). */
export function useLayoutHideHeader() {
  const route = useRoute();
  const hideHeader = ref(false);

  provide(layoutHideHeaderKey, hideHeader);

  watch(() => route.fullPath, () => {
    hideHeader.value = false;
  });

  return { hideHeader };
}

/** Page: set hideHeader from existing page query data — no extra fetch. */
export function syncLayoutHideHeader(pageData: Ref<PageQueryData>) {
  const hideHeader = inject<Ref<boolean>>(layoutHideHeaderKey);

  if (!hideHeader) {
    return;
  }

  watch(
    () => pageData.value?.page?.hideHeader,
    (value) => {
      hideHeader.value = value ?? false;
    },
    { immediate: true },
  );
}
